import { gql } from "@apollo/client";

export const UpdateStarredInstalledBaseNode = gql`
    mutation UpdateStarredInstalledBaseNode($id: ID!, $starred: Boolean!) {
        updateStarredInstalledBaseNode(id: $id, starred: $starred) {
            id
            isStarred
        }
    }
`;
